import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment as config } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';

const API = config.stats.url;

@Injectable()
export class StatsService {
  options: any;
  constructor(private http: Http, private authHttp: AuthHttp) {}

  call(url: string) {
    return this.authHttp
      .get(url, this.options)
      .map(response => response.json())
      .catch(this.handleError);
  }
  getStats(id: number) {
    return this.call(`${API}/views/${id}`);
  }
  getStatsMergedBy(id, filter) {
    return this.call(`${this.getStatsMergedByUrl(id, filter)}`);
  }
  getStatsMergedByUrl(id, filter) {
    return `${API}/views/${id}/merge/${filter}`;
  }
  getBestUsers(id, limit) {
    return this.call(`${this.getBestUsersUrl(id)}/${limit}`);
  }
  getBestUsersUrl(id) {
    return `${API}/users/${id}/best`;
  }
  getAllUsersMergedUrl(id) {
    return `${API}/users/${id}/merged`;
  }
  getBestVisits(id, limit) {
    return this.call(`${this.getBestVisitsUrl(id)}/${limit}`);
  }
  getBestVisitsUrl(id) {
    return `${API}/users/${id}/visit`;
  }
  getTimeSpentMean(id) {
    return this.call(`${this.getTimeSpentMeanUrl(id)}`);
  }
  getTimeSpentMeanUrl(id) {
    return `${API}/users/${id}/time/mean`;
  }
  getDistinctHits(id) {
    return this.call(`${this.getDistinctHitsUrl(id)}`);
  }
  getDistinctHitsUrl(id) {
    return `${API}/views/${id}/hits/distinct`;
  }
  getHitsTotal(id) {
    return this.call(`${this.getHitsTotalUrl(id)}`);
  }
  getHitsTotalUrl(id) {
    return `${API}/views/${id}/hits/total`;
  }
  getConcurrentUsers(id) {
    return this.call(`${this.getConcurrentUsersUrl(id)}`);
  }
  getConcurrentUsersUrl(id) {
    return `${API}/users/${id}/concurrent`;
  }
  handleError(error: any) {
    const errorMsg = error._body
      ? (JSON.parse(error._body) || {}).message
      : 'Yikes! There was was a problem with our stats service';
    return Observable.throw(errorMsg);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/stats.service.ts